export default "__VITE_ASSET__DjhAApns__"